export const DEFAULT_ANCHORED_PORTAL_GAP = 4;
export const DEFAULT_ANCHORED_PORTAL_VIEWPORT_MARGIN = 8;

export const getDefaultAnchoredPortalCoords = ({
	anchorRect,
	layerRect,
	viewport,
	gap = DEFAULT_ANCHORED_PORTAL_GAP,
	viewportMargin = DEFAULT_ANCHORED_PORTAL_VIEWPORT_MARGIN,
}) => {
	let top = anchorRect.bottom + gap;
	let left = anchorRect.right;

	if (top + layerRect.height > viewport.height - viewportMargin) {
		const flippedTop = anchorRect.top - gap - layerRect.height;

		top =
			flippedTop >= viewportMargin
				? flippedTop
				: Math.max(viewportMargin, viewport.height - layerRect.height - viewportMargin);
	}

	if (left - layerRect.width < viewportMargin) {
		left = layerRect.width + viewportMargin;
	}

	if (left > viewport.width - viewportMargin) {
		left = viewport.width - viewportMargin;
	}

	return { top, left };
};
